/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
export function NOOP_ATTRIBUTES_TRANSFORMER(attributes) {
    return attributes;
}
export function NATIVE_XHR_SENDER(url, data, headers) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    const defaultHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };
    Object.entries(Object.assign(Object.assign({}, defaultHeaders), headers)).forEach(([k, v]) => {
        xhr.setRequestHeader(k, v);
    });
    xhr.send(data);
}
export const NATIVE_BEACON_SENDER = typeof navigator !== 'undefined' && navigator.sendBeacon
    ? (url, data, blobPropertyBag) => {
        const payload = blobPropertyBag ? new Blob([data], blobPropertyBag) : data;
        navigator.sendBeacon(url, payload);
    }
    : undefined;
//# sourceMappingURL=common.js.map